
import { ModelBase } from 'store/model-base';
import { StoreAction, XmAction } from 'store/actions';
import { Cart, NavCart } from './models';

// tslint:disable:prefer-object-spread
export function cartReducer(state: Cart, action: XmAction<ModelBase>): Cart {
    switch (action.type) {
        case StoreAction.GET_CART:
            return <Cart> action.payload;
        default:
            return state;
    }
}
// tslint:enable:prefer-object-spread

export function navCartReducer(state: NavCart, action: XmAction<NavCart>): NavCart {
    switch (action.type) {
        case StoreAction.GET_CART_COUNT:
            return action.payload;
        default:
            return state;
    }
}
